import React, { useEffect, useState } from "react";
import OrdersByProductId from "../Orders/OrdersByProductId";
import adminProductService from "../../db/admin-product-service";
import { countryCurrencyMap } from "../../db/init-data";
import { normalizeGitHubUrl } from "../../utils/normalizeGitHubUrl";
import "./AdminProductDetails.scss";

const ProductDetails = (props) => {
  const [productDetails, setProductDetails] = useState(true);
  const [productName, setProductName] = useState("");
  const [productDesc, setProductDesc] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [unit, setUnit] = useState("Kg");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFront, setImageFront] = useState("");
  const [imageBack, setImageBack] = useState("");
  const [imageSide, setImageSide] = useState("");
  const [imageDetail, setImageDetail] = useState("");
  const [galleryImages, setGalleryImages] = useState(["", "", "", ""]);
  const [isOrganic, setIsOrganic] = useState(0);
  const [productHighlights, setProductHighlights] = useState("");
  const [appearance, setAppearance] = useState("");
  const [benefits, setBenefits] = useState("");
  const [shelfLife, setShelfLife] = useState("");
  const [countryOfOrigin, setCountryOfOrigin] = useState("India");
  const [brandName, setBrandName] = useState("Organic");
  const [disclaimer, setDisclaimer] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [category, setCategory] = useState([]);
  const [showBulkUpload, setShowBulkUpload] = useState(false);
  const [csvData, setCsvData] = useState("");
  const [cardBenefit, setCardBenefit] = useState("");
  const [cardPackageInfo, setCardPackageInfo] = useState("");
  const [cardKeyFeatures, setCardKeyFeatures] = useState("");
  const [highlights, setHighlights] = useState("");
  const [ingredients, setIngredients] = useState("");
  const [usageInstructions, setUsageInstructions] = useState("");
  const [storageInstructions, setStorageInstructions] = useState("");
  const [certifications, setCertifications] = useState("");
  
  // Country-specific pricing
  const [pricingUSD, setPricingUSD] = useState(0);
  const [pricingINR, setPricingINR] = useState(0);
  const [pricingGBP, setPricingGBP] = useState(0);
  const [pricingEUR, setPricingEUR] = useState(0);
  const [pricingJPY, setPricingJPY] = useState(0);
  
  // Country-specific stock
  const [stockUS, setStockUS] = useState(0);
  const [stockIN, setStockIN] = useState(0);
  const [stockGB, setStockGB] = useState(0);
  const [stockEU, setStockEU] = useState(0);
  const [stockJP, setStockJP] = useState(0);
  
  // Country availability
  const [availability, setAvailability] = useState(['US', 'IN', 'GB', 'EU', 'JP']);

  const fetchProductDetails = async () => {
    setLoading(true);
    try {
      const productId = String(props.productId);
      console.log("Fetching product details for ID:", productId);
      
      const product = await adminProductService.getProductById(productId);
      console.log("Product details fetched:", product);
      console.log("Product name:", product.name);
      console.log("Product description:", product.description);
      console.log("Product pricing:", product.pricing);
      console.log("Product countryStock:", product.countryStock);
      console.log("Product availability:", product.availability);
      
      setProductName(product.name);
      setProductDesc(product.description);
      setIsActive(product.active !== false); // Default to true if not specified
      setUnit(product.unit || "Kg");
      setImageUrl(product.image_url ? product.image_url.replace('https://raw.githubusercontent.com/sendvijay18/OGH_PROG_V1/main/public/assets/products/', '/') : "");
      setImageFront(product.imageFront || "");
      setImageBack(product.imageBack || "");
      setImageSide(product.imageSide || "");
      setImageDetail(product.imageDetail || "");
      setGalleryImages(product.galleryImages || ["", "", "", ""]);
      setIsOrganic(product.is_organic || 0);
      setProductHighlights(product.productHighlights || "");
      setAppearance(product.appearance || "");
      setBenefits(product.benefits || "");
      setShelfLife(product.shelfLife || "");
      setCountryOfOrigin(product.countryOfOrigin || "India");
      setBrandName(product.brandName || "Organic");
      setDisclaimer(product.disclaimer || "");
      setVideoUrl(product.videoUrl || "");
      setCardBenefit(product.cardBenefit || "");
      setCardPackageInfo(product.cardPackageInfo || "");
      setCardKeyFeatures(product.cardKeyFeatures || "");
      setHighlights(product.highlights || "");
      setIngredients(product.ingredients || "");
      setUsageInstructions(product.usageInstructions || "");
      setStorageInstructions(product.storageInstructions || "");
      setCertifications(product.certifications || "");
      
      console.log('Loaded product data:', {
        cardBenefit: product.cardBenefit,
        cardPackageInfo: product.cardPackageInfo,
        cardKeyFeatures: product.cardKeyFeatures,
        highlights: product.highlights,
        ingredients: product.ingredients,
        usageInstructions: product.usageInstructions,
        storageInstructions: product.storageInstructions,
        certifications: product.certifications
      });
      const categoryArray = product.category ? (Array.isArray(product.category) ? product.category : [product.category]) : [];
      console.log('Setting category from product:', product.category, 'as array:', categoryArray);
      setCategory(categoryArray);
      
      // Set pricing data
      if (product.pricing) {
        setPricingUSD(product.pricing.USD || 0);
        setPricingINR(product.pricing.INR || 0);
        setPricingGBP(product.pricing.GBP || 0);
        setPricingEUR(product.pricing.EUR || 0);
        setPricingJPY(product.pricing.JPY || 0);
      } else {
        // Legacy product with single price
        setPricingUSD(product.price || 0);
        setPricingINR(0);
        setPricingGBP(0);
        setPricingEUR(0);
        setPricingJPY(0);
      }
      
      // Set stock data
      if (product.countryStock) {
        setStockUS(product.countryStock.US || 0);
        setStockIN(product.countryStock.IN || 0);
        setStockGB(product.countryStock.GB || 0);
        setStockEU(product.countryStock.EU || 0);
        setStockJP(product.countryStock.JP || 0);
      } else {
        // Legacy product with single stock
        const defaultStock = product.stock || 0;
        setStockUS(defaultStock);
        setStockIN(defaultStock);
        setStockGB(defaultStock);
        setStockEU(defaultStock);
        setStockJP(defaultStock);
      }
      
      // Set availability
      if (product.availability) {
        setAvailability(product.availability);
      } else {
        setAvailability(['US', 'IN', 'GB', 'EU', 'JP']);
      }
      
      setProductDetails(true);
      setError(null);
    } catch (err) {
      console.error("Sorry couldn't fetch details", err);
      setProductDetails(false);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryChange = (categoryValue, isChecked) => {
    if (isChecked) {
      if (!category.includes(categoryValue)) {
        setCategory([...category, categoryValue]);
      }
    } else {
      setCategory(category.filter(c => c !== categoryValue));
    }
  };

  useEffect(() => {
    if (props.productId) {
      fetchProductDetails();
    } else {
      console.warn("No product ID provided");
      setLoading(false);
      setError("No product ID provided");
    }
  }, [props.productId]);

  const handleImageUpload = (e, setImageState) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageState(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleGalleryImageUpload = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newGallery = [...galleryImages];
        newGallery[index] = reader.result;
        setGalleryImages(newGallery);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAvailabilityChange = (country, isChecked) => {
    if (isChecked) {
      if (!availability.includes(country)) {
        setAvailability([...availability, country]);
      }
    } else {
      setAvailability(availability.filter(c => c !== country));
    }
  };

  const clearGalleryImage = (index) => {
    const newGallery = [...galleryImages];
    newGallery[index] = "";
    setGalleryImages(newGallery);
  };

  const saveProduct = async () => {
    try {
      // Create pricing object with currency codes
      const pricing = {};
      
      // Map country prices to their currency codes
      pricing.USD = parseFloat(pricingUSD) || 0;
      pricing.INR = parseFloat(pricingINR) || 0;
      pricing.GBP = parseFloat(pricingGBP) || 0;
      pricing.EUR = parseFloat(pricingEUR) || 0;
      pricing.JPY = parseFloat(pricingJPY) || 0;
      
      // Create stock object with only selected countries
      const countryStock = {};
      
      // Always include all stock values, even if country is not in availability
      countryStock.US = parseInt(stockUS) || 0;
      countryStock.IN = parseInt(stockIN) || 0;
      countryStock.GB = parseInt(stockGB) || 0;
      countryStock.EU = parseInt(stockEU) || 0;
      countryStock.JP = parseInt(stockJP) || 0;
      
      // Log the data being sent
      console.log("Saving product with pricing:", pricing);
      console.log("Saving product with stock:", countryStock);
      
      console.log("Saving product with category:", category);
      
      const productData = {
        name: productName,
        description: productDesc,
        pricing: pricing,
        countryStock: countryStock,
        availability: availability,
        active: isActive,
        unit: unit,
        image_url: imageUrl,
        galleryImages: galleryImages.filter(img => img && img.trim()),
        is_organic: parseInt(isOrganic),
        productHighlights: productHighlights,
        appearance: appearance,
        benefits: benefits,
        shelfLife: shelfLife,
        countryOfOrigin: countryOfOrigin,
        brandName: brandName,
        disclaimer: disclaimer,
        videoUrl: videoUrl,
        category: category,
        cardBenefit: cardBenefit,
        cardPackageInfo: cardPackageInfo,
        cardKeyFeatures: cardKeyFeatures,
        highlights: highlights,
        ingredients: ingredients,
        usageInstructions: usageInstructions,
        storageInstructions: storageInstructions,
        certifications: certifications
      };
      
      console.log("Saving product with all fields:", JSON.stringify(productData, null, 2));
      
      // Ensure productId is a string
      const productId = String(props.productId);
      console.log("Updating product:", productId, JSON.stringify(productData, null, 2));
      
      // Use PouchDB admin product service instead of API call
      const result = await adminProductService.updateProduct(productId, productData);
      console.log("Update result:", result);
      
      alert("Product updated successfully");
      
      // Refresh product details to show the updated data
      fetchProductDetails();
    } catch (err) {
      console.error("Error updating product:", err);
      alert("Failed to update product: " + err.message);
    }
  };

  const handleBackClickToProductList = () => {
    props.onBackClick();
  };

  const downloadTemplate = () => {
    const template = `name,description,image_url,is_organic,unit,pricing_USD,pricing_INR,pricing_GBP,pricing_EUR,pricing_JPY,stock_US,stock_IN,stock_GB,stock_EU,stock_JP,availability,productHighlights,appearance,benefits,shelfLife,countryOfOrigin,brandName,disclaimer
Organic Carrots,Fresh organic carrots,https://example.com/carrot.jpg,1,kg,4.99,415,3.95,4.60,755,30,25,20,35,15,"US,IN,GB,EU,JP","Our wholesome organic english carrot (gajar) are cultivated on certified organic farms","Organic english carrot are root vegetables usually orange in colour","• Rich source of Vitamin A\n• Good source of sodium and potassium","• Can stay fresh for 3-5 days under room temperature\n• Refrigerated carrots kept in wet paper towels may stay fresh up to 2 weeks",India,Organic,"All our fruits and vegetables are sourced from certified organic farms"`;
    
    const blob = new Blob([template], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'product_template.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const processBulkUpload = async () => {
    if (!csvData.trim()) {
      alert('Please paste CSV data first');
      return;
    }

    try {
      const lines = csvData.trim().split('\n');
      const headers = lines[0].split(',').map(h => h.trim());
      
      const products = [];
      
      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(',').map(v => v.trim().replace(/^"|"$/g, ''));
        
        if (values.length !== headers.length) {
          console.warn(`Skipping line ${i + 1}: column count mismatch`);
          continue;
        }
        
        const product = {
          _id: `product_bulk_${Date.now()}_${i}`,
          type: 'product',
          name: values[headers.indexOf('name')] || '',
          description: values[headers.indexOf('description')] || '',
          image_url: values[headers.indexOf('image_url')] || '',
          is_organic: parseInt(values[headers.indexOf('is_organic')]) || 0,
          unit: values[headers.indexOf('unit')] || 'kg',
          pricing: {
            USD: parseFloat(values[headers.indexOf('pricing_USD')]) || 0,
            INR: parseFloat(values[headers.indexOf('pricing_INR')]) || 0,
            GBP: parseFloat(values[headers.indexOf('pricing_GBP')]) || 0,
            EUR: parseFloat(values[headers.indexOf('pricing_EUR')]) || 0,
            JPY: parseFloat(values[headers.indexOf('pricing_JPY')]) || 0
          },
          countryStock: {
            US: parseInt(values[headers.indexOf('stock_US')]) || 0,
            IN: parseInt(values[headers.indexOf('stock_IN')]) || 0,
            GB: parseInt(values[headers.indexOf('stock_GB')]) || 0,
            EU: parseInt(values[headers.indexOf('stock_EU')]) || 0,
            JP: parseInt(values[headers.indexOf('stock_JP')]) || 0
          },
          availability: values[headers.indexOf('availability')]?.split(',').map(c => c.trim()) || ['US', 'IN'],
          productHighlights: values[headers.indexOf('productHighlights')] || '',
          appearance: values[headers.indexOf('appearance')] || '',
          benefits: values[headers.indexOf('benefits')] || '',
          shelfLife: values[headers.indexOf('shelfLife')] || '',
          countryOfOrigin: values[headers.indexOf('countryOfOrigin')] || 'India',
          brandName: values[headers.indexOf('brandName')] || 'Organic',
          disclaimer: values[headers.indexOf('disclaimer')] || '',
          active: true,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        };
        
        products.push(product);
      }
      
      console.log('Processing bulk upload:', products);
      
      // Use PouchDB to bulk insert
      const result = await adminProductService.bulkCreateProducts(products);
      
      alert(`Successfully uploaded ${products.length} products!`);
      setCsvData('');
      setShowBulkUpload(false);
      
    } catch (error) {
      console.error('Bulk upload error:', error);
      alert('Error processing bulk upload: ' + error.message);
    }
  };

  if (loading) {
    return <div>Loading product details...</div>;
  }

  if (error && !productDetails) {
    return (
      <div className="product-details-container">
        <div className="top-right">
          <button onClick={handleBackClickToProductList}>Back</button>
        </div>
        <div className="error-message">
          Error loading product: {error}
        </div>
      </div>
    );
  }

  return (
    <div className="product-details-container">
      <div className="top-right">
        <button onClick={handleBackClickToProductList}>Back</button>
      </div>
      {productDetails ? (
        <>
          <div>Product ID: {props.productId}</div>
          <input
            type="text"
            value={props.productId || ""}
            disabled
            placeholder="Product Id"
          />
          <input
            type="text"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            placeholder="Product Name"
          />
          
          <div className="form-group">
            <label htmlFor="imageUrl">Main Product Image URL:</label>
            <input
              type="text"
              id="imageUrl"
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
              placeholder="/ABC_Juice_1.png"
            />
            <small style={{color: '#666', marginTop: '5px', display: 'block'}}>Use format: /ImageName.png</small>
            {imageUrl && <img src={imageUrl} alt="Preview" style={{maxWidth: '200px', marginTop: '10px', borderRadius: '4px'}} onError={(e) => e.target.src = 'https://placehold.co/200x200?text=Not+Found'} />}
          </div>
          
          <div className="gallery-section">
            <h3>Gallery Images</h3>
            <p style={{fontSize: '12px', color: '#666', marginBottom: '10px'}}>Use format: /ImageName.png</p>
            <div className="gallery-grid">
              {[0, 1, 2, 3].map((idx) => (
                <div key={idx} className="gallery-upload">
                  <label htmlFor={`gallery-${idx}`}>Image {idx + 1} URL</label>
                  <input
                    type="text"
                    id={`gallery-${idx}`}
                    placeholder="/ABC_Juice_2.png"
                    value={galleryImages[idx]}
                    onChange={(e) => {
                      const newGallery = [...galleryImages];
                      newGallery[idx] = e.target.value;
                      setGalleryImages(newGallery);
                    }}
                  />
                  {galleryImages[idx] && (
                    <>
                      <img src={galleryImages[idx]} alt={`Gallery ${idx + 1}`} className="gallery-preview" onError={(e) => e.target.src = 'https://placehold.co/150x150?text=Not+Found'} />
                      <button
                        type="button"
                        onClick={() => {
                          const newGallery = [...galleryImages];
                          newGallery[idx] = "";
                          setGalleryImages(newGallery);
                        }}
                        className="clear-button"
                      >
                        Clear
                      </button>
                    </>
                  )}
                  {!galleryImages[idx] && <small>No URL entered</small>}
                </div>
              ))}
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="unit">Unit:</label>
            <select
              id="unit"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
            >
              <option value="kg">Kg</option>
              <option value="grams">grams</option>
              <option value="liters">liters</option>
              <option value="ml">ml</option>
              <option value="shot">shot</option>
              <option value="unit">unit</option>
              <option value="each">each</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="isOrganic">Organic Status:</label>
            <select
              id="isOrganic"
              value={isOrganic}
              onChange={(e) => setIsOrganic(e.target.value)}
            >
              <option value={0}>Not Organic</option>
              <option value={1}>Certified Organic</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="countryOfOrigin">Country of Origin:</label>
            <input
              type="text"
              id="countryOfOrigin"
              value={countryOfOrigin}
              onChange={(e) => setCountryOfOrigin(e.target.value)}
              placeholder="India"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="brandName">Brand Name:</label>
            <input
              type="text"
              id="brandName"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
              placeholder="Organic"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="videoUrl">YouTube Embed URL:</label>
            <input
              type="url"
              id="videoUrl"
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              placeholder="https://www.youtube.com/embed/dQw4w9WgXcQ"
            />
            <small>Use embed format: youtube.com/embed/VIDEO_ID (not youtube.com/watch?v=)</small>
            {videoUrl && (
              <iframe
                width="100%"
                height="300"
                src={videoUrl}
                title="Product Video Preview"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{marginTop: '10px', borderRadius: '4px'}}
              />
            )}
          </div>
          
          <div className="form-group">
            <label>Categories:</label>
            <div className="category-checkboxes">
              <label>
                <input
                  type="checkbox"
                  checked={category.includes('metabolic')}
                  onChange={(e) => handleCategoryChange('metabolic', e.target.checked)}
                />
                Blood Sugar Support
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={category.includes('cardiovascular')}
                  onChange={(e) => handleCategoryChange('cardiovascular', e.target.checked)}
                />
                Heart Health
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={category.includes('immunity')}
                  onChange={(e) => handleCategoryChange('immunity', e.target.checked)}
                />
                Immunity Boost
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={category.includes('digestive')}
                  onChange={(e) => handleCategoryChange('digestive', e.target.checked)}
                />
                Gut Health
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={category.includes('detox')}
                  onChange={(e) => handleCategoryChange('detox', e.target.checked)}
                />
                Detox & Repair
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={category.includes('premium')}
                  onChange={(e) => handleCategoryChange('premium', e.target.checked)}
                />
                Premium
              </label>
            </div>
          </div>
          
          <div className="status-section">
            <h3>Product Status</h3>
            <div className="status-toggle">
              <label>
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                />
                Active
              </label>
              <div className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
                {isActive ? 'Active' : 'Inactive'}
              </div>
            </div>
          </div>
          
          <div className="pricing-section">
            <h3>Pricing</h3>
            <div className="price-inputs">
              <div className="price-input">
                <label>USD ($)</label>
                <input
                  type="number"
                  step="0.01"
                  value={pricingUSD}
                  onChange={(e) => setPricingUSD(e.target.value)}
                  placeholder="USD Price"
                  disabled={!availability.includes('US')}
                />
              </div>
              <div className="price-input">
                <label>INR (₹)</label>
                <input
                  type="number"
                  step="0.01"
                  value={pricingINR}
                  onChange={(e) => setPricingINR(e.target.value)}
                  placeholder="INR Price"
                  disabled={!availability.includes('IN')}
                />
              </div>
              <div className="price-input">
                <label>GBP (£)</label>
                <input
                  type="number"
                  step="0.01"
                  value={pricingGBP}
                  onChange={(e) => setPricingGBP(e.target.value)}
                  placeholder="GBP Price"
                  disabled={!availability.includes('GB')}
                />
              </div>
              <div className="price-input">
                <label>EUR (€)</label>
                <input
                  type="number"
                  step="0.01"
                  value={pricingEUR}
                  onChange={(e) => setPricingEUR(e.target.value)}
                  placeholder="EUR Price"
                  disabled={!availability.includes('EU')}
                />
              </div>
              <div className="price-input">
                <label>JPY (¥)</label>
                <input
                  type="number"
                  step="0.01"
                  value={pricingJPY}
                  onChange={(e) => setPricingJPY(e.target.value)}
                  placeholder="JPY Price"
                  disabled={!availability.includes('JP')}
                />
              </div>
            </div>
          </div>
          
          <div className="stock-section">
            <h3>Stock by Country</h3>
            <div className="stock-inputs">
              <div className="stock-input">
                <label>US Stock</label>
                <input
                  type="number"
                  value={stockUS}
                  onChange={(e) => setStockUS(e.target.value)}
                  placeholder="US Stock"
                  disabled={!availability.includes('US')}
                />
              </div>
              <div className="stock-input">
                <label>India Stock</label>
                <input
                  type="number"
                  value={stockIN}
                  onChange={(e) => setStockIN(e.target.value)}
                  placeholder="India Stock"
                  disabled={!availability.includes('IN')}
                />
              </div>
              <div className="stock-input">
                <label>UK Stock</label>
                <input
                  type="number"
                  value={stockGB}
                  onChange={(e) => setStockGB(e.target.value)}
                  placeholder="UK Stock"
                  disabled={!availability.includes('GB')}
                />
              </div>
              <div className="stock-input">
                <label>Europe Stock</label>
                <input
                  type="number"
                  value={stockEU}
                  onChange={(e) => setStockEU(e.target.value)}
                  placeholder="Europe Stock"
                  disabled={!availability.includes('EU')}
                />
              </div>
              <div className="stock-input">
                <label>Japan Stock</label>
                <input
                  type="number"
                  value={stockJP}
                  onChange={(e) => setStockJP(e.target.value)}
                  placeholder="Japan Stock"
                  disabled={!availability.includes('JP')}
                />
              </div>
            </div>
          </div>
          
          <div className="availability-section">
            <h3>Available In</h3>
            <div className="country-checkboxes">
              <label>
                <input
                  type="checkbox"
                  checked={availability.includes('US')}
                  onChange={(e) => handleAvailabilityChange('US', e.target.checked)}
                />
                United States
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={availability.includes('IN')}
                  onChange={(e) => handleAvailabilityChange('IN', e.target.checked)}
                />
                India
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={availability.includes('GB')}
                  onChange={(e) => handleAvailabilityChange('GB', e.target.checked)}
                />
                United Kingdom
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={availability.includes('EU')}
                  onChange={(e) => handleAvailabilityChange('EU', e.target.checked)}
                />
                Europe
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={availability.includes('JP')}
                  onChange={(e) => handleAvailabilityChange('JP', e.target.checked)}
                />
                Japan
              </label>
            </div>
          </div>
          
          <div className="detailed-info-section">
            <h3>Detailed Product Information</h3>
            
            <div className="form-group">
              <label htmlFor="cardBenefit">Card Benefit (Line 1):</label>
              <input
                type="text"
                id="cardBenefit"
                value={cardBenefit}
                onChange={(e) => setCardBenefit(e.target.value)}
                placeholder="e.g., Digestive Aid"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="cardPackageInfo">Card Package Info (Line 2):</label>
              <input
                type="text"
                id="cardPackageInfo"
                value={cardPackageInfo}
                onChange={(e) => setCardPackageInfo(e.target.value)}
                placeholder="e.g., 12 or more Glass Bottles"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="cardKeyFeatures">Card Key Features (Line 3):</label>
              <input
                type="text"
                id="cardKeyFeatures"
                value={cardKeyFeatures}
                onChange={(e) => setCardKeyFeatures(e.target.value)}
                placeholder="e.g., 17g of Fresh Ginger | 20mg of Vitamin C"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="highlights">Product Highlights:</label>
              <textarea
                id="highlights"
                value={highlights}
                onChange={(e) => setHighlights(e.target.value)}
                placeholder="• 100% Organic ingredients\n• Cold-pressed for maximum potency\n• No artificial additives"
                rows={4}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="ingredients">Ingredients:</label>
              <textarea
                id="ingredients"
                value={ingredients}
                onChange={(e) => setIngredients(e.target.value)}
                placeholder="Organic ginger root juice, organic cayenne pepper, organic lemon juice, filtered water"
                rows={3}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="usageInstructions">Usage Instructions:</label>
              <textarea
                id="usageInstructions"
                value={usageInstructions}
                onChange={(e) => setUsageInstructions(e.target.value)}
                placeholder="Take 1 shot daily. Can be consumed straight or mixed with water. Best taken in the morning."
                rows={3}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="storageInstructions">Storage Instructions:</label>
              <textarea
                id="storageInstructions"
                value={storageInstructions}
                onChange={(e) => setStorageInstructions(e.target.value)}
                placeholder="Store in refrigerator. Consume within 3 days of opening. Keep away from direct sunlight."
                rows={3}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="certifications">Certifications & Standards:</label>
              <textarea
                id="certifications"
                value={certifications}
                onChange={(e) => setCertifications(e.target.value)}
                placeholder="USDA Organic Certified, Kosher, Gluten Free, Vegan, Lab Tested"
                rows={2}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="productHighlights">Product Highlights (Legacy):</label>
              <textarea
                id="productHighlights"
                value={productHighlights}
                onChange={(e) => setProductHighlights(e.target.value)}
                placeholder="Our wholesome organic product details, cultivation methods, farm to store policy..."
                rows={4}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="appearance">Appearance:</label>
              <textarea
                id="appearance"
                value={appearance}
                onChange={(e) => setAppearance(e.target.value)}
                placeholder="Physical description, color, shape, size variations..."
                rows={3}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="benefits">Benefits:</label>
              <textarea
                id="benefits"
                value={benefits}
                onChange={(e) => setBenefits(e.target.value)}
                placeholder="• Rich source of Vitamin A\n• Good source of sodium and potassium\n• Great source of antioxidants"
                rows={4}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="shelfLife">Shelf Life:</label>
              <textarea
                id="shelfLife"
                value={shelfLife}
                onChange={(e) => setShelfLife(e.target.value)}
                placeholder="• Can stay fresh for 3-5 days under room temperature\n• Refrigerated storage instructions"
                rows={3}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="disclaimer">Disclaimer:</label>
              <textarea
                id="disclaimer"
                value={disclaimer}
                onChange={(e) => setDisclaimer(e.target.value)}
                placeholder="All our fruits and vegetables are sourced from certified organic farms..."
                rows={4}
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="description">Basic Description:</label>
            <textarea
              id="description"
              value={productDesc}
              onChange={(e) => setProductDesc(e.target.value)}
              placeholder="Short product description"
              rows={2}
            />
          </div>
          
          <div className="action-buttons">
            <button onClick={(e) => saveProduct()} className="save-button">Save Product</button>
            <button onClick={() => setShowBulkUpload(!showBulkUpload)} className="bulk-upload-button">
              {showBulkUpload ? 'Hide' : 'Show'} Bulk Upload
            </button>
          </div>
          
          {showBulkUpload && (
            <div className="bulk-upload-section">
              <h3>Bulk Product Upload</h3>
              <div className="template-section">
                <h4>CSV Template:</h4>
                <button onClick={downloadTemplate} className="download-template-button">
                  Download CSV Template
                </button>
                <div className="template-preview">
                  <small>Template includes: name, description, image_url, is_organic, unit, pricing (USD,INR,GBP,EUR,JPY), stock (US,IN,GB,EU,JP), availability, productHighlights, appearance, benefits, shelfLife, countryOfOrigin, brandName, disclaimer</small>
                </div>
              </div>
              
              <div className="csv-input-section">
                <label htmlFor="csvData">Paste CSV Data:</label>
                <textarea
                  id="csvData"
                  value={csvData}
                  onChange={(e) => setCsvData(e.target.value)}
                  placeholder="Paste your CSV data here or use the template above"
                  rows={10}
                  className="csv-textarea"
                />
                <button onClick={processBulkUpload} className="process-bulk-button">
                  Process Bulk Upload
                </button>
              </div>
            </div>
          )}
        </>
      ) : null}

      <OrdersByProductId productId={String(props.productId)} />
    </div>
  );
};

export default ProductDetails;